
import ReactApexChart from 'react-apexcharts';
export const timeLineChart = (series,y="Orders",stroke="smooth",type=1) =>{
   
    series.forEach(item => {
        item.data = item.data.map(value => value / 60);
    });
    
  let dataLabel=[0,1,2]
  if(type==2){
    dataLabel=[0]
  }
     const options= {
      chart: {
        height: 350,
        type: 'line',
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: false
        }
      },
      colors: ['#C0031B', '#545454','#0860FA'],
      dataLabels: {
         enabled: false,
        enabledOnSeries: dataLabel
      },
      stroke: {
        curve: stroke
      },
     
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      markers: {
        size: 1
      },
      xaxis: {
        categories: series[0].x,
        title: {
          text: 'Month'
        }
      },
      yaxis: {
        title: {
          text:y
        },
        labels: {
            formatter: function (value) {
              const hours = Math.floor(value);
              const minutes = Math.floor((value - hours) * 60);
              if (hours === 0 && minutes === 0) {
                return '0 min';
              } else if (hours === 0) {
                return `${minutes} mins`;
              } else if (minutes === 0) {
                return `${hours} hours`;
              } else {
                return `${hours} hours ${minutes} mins`;
              }
            }
          }

      },
      
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: 2,
        offsetX: -5
      }
    }
     return (
       <div>
          <ReactApexChart options={options} series={series} type="line" height  ={400} />
       </div>
     )

  }